import { DOWNLOAD_QMS_FEEDBACK_DETAILS_DATA, GET_QMS_FEEDBACK_DETAILs_DATA } from "../../../constants";

export function getQMSFeedbackDetails(data) {
    return {
        type: GET_QMS_FEEDBACK_DETAILs_DATA,
        data,
    };
}

export function downloadQMSFeedbackDetails(data) {
    return {
        type: DOWNLOAD_QMS_FEEDBACK_DETAILS_DATA,
        data,
    };
}